import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { SourceData } from '@core/tellent-assistant-types';
import { IconContainerComponent, type IconName } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

const PROVIDER_ICONS: Record<string, IconName> = {
  notion: 'notion',
};

@Component({
  selector: 'rt-list-item-source',
  imports: [ListCardComponent, IconContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-source.component.html',
  styleUrl: './list-item-source.component.less',
})
export class ListItemSourceComponent {
  protected readonly icon = computed<IconName>(
    () => PROVIDER_ICONS[this.data().provider ?? ''] ?? 'file-document',
  );

  // Synced documents carry file:// paths — never expose those as links.
  protected readonly href = computed<string | null>(() => {
    const url = this.data().url;
    return url?.startsWith('http') ? url : null;
  });

  public readonly data = input.required<SourceData>();
}
